import { useRouter } from 'next/router'

import { useQuery } from '@tanstack/react-query'

import { getPortal } from '@/lib/api/other'
import { Portal } from '@/lib/types/articles'

export const usePortal = (key: string = 'portal', enabled: boolean = true) => {
  const router = useRouter()

  const {
    data: articles,
    isFetching,
    isLoading
  } = useQuery<Portal>({
    queryKey: [key, router.locale],
    queryFn: () => getPortal(),
    enabled
  })

  return {
    articles,
    isLoading: isLoading || isFetching
  }
}
